
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (this.form) {
          this.form.addEventListener(
            'submit',
            this.onSubmitHandler.bind(this)
          );
        }

        // Priorizar el carrito lateral de Wokiee.
        this.cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form || !this.submitButton) return;

        if (
          this.submitButton.getAttribute('aria-disabled') ===
          'true'
        ) {
          return;
        }

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute(
          'aria-disabled',
          'true'
        );

        this.submitButton.classList.add('loading');

        const spinner = this.querySelector(
          '.loading-overlay__spinner'
        );

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        // Buscar siempre el carrito actual.
        this.cart =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Solicitar las secciones necesarias para
        // actualizar el carrito lateral de Wokiee.
        if (
          this.cart &&
          typeof this.cart.getSectionsToRender ===
            'function'
        ) {
          const sections =
            this.cart.getSectionsToRender();

          if (Array.isArray(sections)) {
            formData.append(
              'sections',
              sections.map(section => section.id).join(',')
            );

            formData.append(
              'sections_url',
              window.location.pathname
            );
          }

          if (
            typeof this.cart.setActiveElement ===
            'function'
          ) {
            this.cart.setActiveElement(
              document.activeElement
            );
          }
        }

        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors:
                  response.errors ||
                  response.description,
                message: response.message
              });

              this.handleErrorMessage(
                response.description ||
                response.message ||
                'No se ha podido añadir el producto.'
              );

              if (
                response.description &&
                /sold out|agotad|sin stock/i.test(
                  response.description
                )
              ) {
                const soldOutMessage =
                  this.submitButton.querySelector(
                    '.sold-out-message'
                  );

                if (soldOutMessage) {
                  this.submitButton
                    .querySelector('span')
                    ?.classList.add('hidden');

                  soldOutMessage.classList.remove(
                    'hidden'
                  );
                }
              }

              this.error = true;
              return;
            }

            if (
              typeof publish === 'function' &&
              typeof PUB_SUB_EVENTS !== 'undefined'
            ) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response
              });
            }

            this.error = false;

            // Actualizar y abrir el carrito lateral.
            if (
              this.cart &&
              typeof this.cart.renderContents ===
                'function' &&
              response.sections
            ) {
              try {
                this.cart.renderContents(response);
                return;
              } catch (error) {
                console.error(
                  'Error al actualizar carrito lateral:',
                  error
                );
              }
            }

            // Seguridad: si el lateral no está
            // disponible, permitir seguir comprando.
            console.warn(
              'Carrito lateral no disponible. ' +
              'Abriendo carrito completo.'
            );

            window.location.href =
              window.routes?.cart_url || '/cart';
          })
          .catch(error => {
            console.error(
              'Error al añadir al carrito:',
              error
            );

            this.error = true;

            this.handleErrorMessage(
              'No hemos podido actualizar el carrito. ' +
              'Comprueba si el producto se ha añadido ' +
              'antes de volver a intentarlo.'
            );
          })
          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            if (spinner) {
              spinner.classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// Carrito fijo de la ficha de producto.
// Se conserva su comportamiento original.
class stickyCartModal extends HTMLElement {
  constructor() {
    super();

    window.addEventListener(
      'scroll',
      this.update.bind(this)
    );

    this.update();

    this.querySelector('.sticky-cart-button')
      ?.addEventListener(
        'click',
        this.onClickHandler.bind(this)
      );

    this.querySelector('.sticky-cart-button')
      ?.addEventListener(
        'keydown',
        this.onClickKeydownHandler.bind(this)
      );
  }

  update() {
    const sectionId = this.dataset.section;

    const buttonContainer = document.getElementById(
      `product-form-${sectionId}`
    );

    const sect = this.closest(
      '.shopify-section, .popup-modal__content__data'
    );

    const hasSelectOption =
      sect?.querySelector('select-option-js');

    const customAddButton =
      buttonContainer?.querySelector(
        '.select-options-button'
      );

    const addButton =
      hasSelectOption && customAddButton
        ? customAddButton
        : buttonContainer?.querySelector(
            '[name="add"]'
          );

    if (!addButton) return false;

    const rangeToShowModal =
      this.getTop(addButton) +
      addButton.clientHeight;

    if (rangeToShowModal <= 0) return false;

    if (
      window.scrollY >= rangeToShowModal &&
      !this.classList.contains('show-modal')
    ) {
      this.classList.add('show-modal');

      document.body.classList.add(
        'modal__sticky-cart'
      );

      document.querySelector('.footer__content')
        ?.classList.add(
          'sticky-cart-modal_bottom_padding'
        );
    }

    if (
      window.scrollY < rangeToShowModal &&
      this.classList.contains('show-modal')
    ) {
      this.classList.remove('show-modal');

      document.body.classList.remove(
        'modal__sticky-cart'
      );
    }
  }

  onClickKeydownHandler(event) {
    if (
      event.code.toUpperCase() !== 'ENTER'
    ) {
      return false;
    }

    this.onClickHandler();
  }

  onClickHandler() {
    const sectionId = this.dataset.section;

    const form = document.getElementById(
      `product-form-${sectionId}`
    );

    const addButton =
      form?.querySelector('[name="add"]');

    const selectButton =
      form?.querySelector(
        '.select-options-button'
      );

    const selectVisible =
      selectButton &&
      getComputedStyle(selectButton).display !==
        'none';

    if (
      addButton &&
      !addButton.disabled &&
      !selectVisible
    ) {
      addButton.click();
      return;
    }

    const item = document.querySelector(
      '.product__column__content ' +
      '[id*="variant-selects-"]'
    );

    const btnItem =
      document.getElementById(
        'product-container'
      );

    const target = item || btnItem;

    if (!target) return;

    const y = this.getTop(target) - 20;

    this.scrollTo(y, 700);
  }

  lvcDirectStickyAdd() {
    return true;
  }

  getTop(el) {
    if (!el) return 0;

    return el.offsetTop +
      (
        el.offsetParent
          ? this.getTop(el.offsetParent)
          : 0
      );
  }

  scrollTo(to, duration) {
    const element =
      document.scrollingElement ||
      document.documentElement;

    element.scrollTop = to;
  }
}

if (!customElements.get('sticky-cart-modal')) {
  customElements.define(
    'sticky-cart-modal',
    stickyCartModal
  );
}
